import type { Tag } from "@app/types/Cue";
import KeywordFilter from "@components/KeywordFilter";
import { MYBT_EXCLUDE_KEYWORDS } from "@util/constant";

export enum KeywordDisplayOption {
  First = "first",
  Rest = "rest",
}

export type ArticleKeywordsProps = {
  keywords: Tag[];
  keywordDisplayOption?: KeywordDisplayOption;
};

export default function ArticleKeywords({
  keywords,
  keywordDisplayOption,
}: ArticleKeywordsProps): React.ReactElement {
  const tags = keywords.filter((tag) => {
    return !MYBT_EXCLUDE_KEYWORDS.some((t) => t === tag.name);
  });

  switch (keywordDisplayOption) {
    case KeywordDisplayOption.First:
      return (
        <div data-testid="article-keyword-filter-first">
          {tags && tags[0] ? (
            <KeywordFilter
              tag={tags[0]}
              rootClassName="bg-gray-250 p-3 inline-block"
              tagClassName="!text-gray-850"
            />
          ) : null}
        </div>
      );
    case KeywordDisplayOption.Rest:
      return (
        <div data-testid="article-keyword-filter-rest">
          {tags && tags.length > 1 && (
            <div className="border-gray-75 mb-6 mt-3 border-t pt-3">
              <h2 className="mb-3 font-poppins text-lg font-semibold">
                KEYWORDS IN THIS ARTICLE
              </h2>

              <div className="flex flex-wrap gap-3">
                {/* Skip the first keyword as it has already been displayed below the author details */}
                {tags.slice(1).map((keyword) => (
                  <KeywordFilter
                    key={keyword.uri}
                    tag={keyword}
                    rootClassName="bg-gray-250 p-3 inline-block"
                    tagClassName="!text-gray-850"
                    disableTooltip
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      );
    default:
      return <></>;
  }
}
